import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { 
	GetLocal,
	SetLocal,
	FetchService
} from "../Base/BaseControl";
import FetchServiceNeedsLogin, { EmployeeSessionCheckFetch } from "../Base/BasePageEmployee"

export default function Index(props) {
	
	const [getOwnerInfo11, setOwnerInfo11] = useState([]);
	
    useEffect(() => {			
		ShowOwnerResidentialInfo();
    }, []);		

	const ShowOwnerResidentialInfo =()=> {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			fileNumber: GetLocal('FileNumber')
		};
		EmployeeSessionCheckFetch('Employee/Urbanization/Request/ShowOwnerResidentialInfo', inputValue, ShowOwnerResidentialInfoSuccess);		
	}
	
	const ShowOwnerResidentialInfoSuccess =(serviceResult)=>{
		setOwnerInfo11(serviceResult)
	}	

    return (
			<div>
				<div class="row mt-3">
					<div class="col-sm-12">
						<div class="alert alert-primary alert-dismissible fade show text-start" role="alert">
							<span class="bold colorCb4358"><i class="fa fa-file-text text-secondary" aria-hidden="true"></i> شماره پرونده :</span> {getOwnerInfo11.ownerInfo && getOwnerInfo11.ownerInfo.FileNumber} <span class="bold ms-4 colorCb4358"><i class="fa fa-user text-secondary" aria-hidden="true"></i> نام و نام خانوادگی : </span> {getOwnerInfo11.ownerInfo && getOwnerInfo11.ownerInfo.FullName} <span class="bold ms-4 colorCb4358"><i class="fa fa-map-marker text-secondary" aria-hidden="true"></i> نشانی مالک :</span> {getOwnerInfo11.fileInfo && getOwnerInfo11.fileInfo.Address}
						</div>
					</div>
				</div>

				<div class="row text-center justify-content-around">
					<div class="card col-sm-2 m-1">
						<div class="card-body">
							<h5 class="card-title">آپارتمان</h5>
							<p class="card-text badge bg-primary boxFontSize">{getOwnerInfo11.fileInfo && getOwnerInfo11.fileInfo.Apartment}</p>
						</div>
					</div>
					<div class="card col-sm-2 m-1">
						<div class="card-body">
							<h5 class="card-title">ملک</h5>
							<p class="card-text badge bg-primary boxFontSize">{getOwnerInfo11.fileInfo && getOwnerInfo11.fileInfo.Parcel}</p>
						</div>
					</div>
					<div class="card col-sm-2 m-1">
						<div class="card-body">
							<h5 class="card-title">بلوک </h5>
							<p class="card-text badge bg-primary boxFontSize">{getOwnerInfo11.fileInfo && getOwnerInfo11.fileInfo.Block}</p>
						</div>
					</div>
					<div class="card col-sm-2 m-1">
						<div class="card-body">
							<h5 class="card-title">محله</h5>
							<p class="card-text badge bg-primary boxFontSize">{getOwnerInfo11.fileInfo && getOwnerInfo11.fileInfo.District}</p>
						</div>
					</div>
					<div class="card col-sm-2 m-1">
						<div class="card-body">
							<h5 class="card-title">منطقه</h5>
							<p class="card-text badge bg-primary boxFontSize">{getOwnerInfo11.fileInfo && getOwnerInfo11.fileInfo.Area}</p>
						</div>
					</div>
				</div>

				<div class="row mt-3">
					<div class="col-sm-12">
						<div class="alert alert-warning alert-dismissible fade show text-start" role="alert">
							<i class="fa fa-file-text text-secondary" aria-hidden="true"></i> {getOwnerInfo11.fileState && getOwnerInfo11.fileState.State}
						</div>
					</div>
				</div>
			</div>
    )
}